export const enum AuditLogAction {
  Read = 'read',
  Create = 'create',
  Update = 'update',
  Delete = 'delete',

  Rebuild = 'rebuild',
  Rerun = 'rerun',
  Dropoff = 'dropoff'
}
